/* R-PUR : estimation de la durée de vie du filtre en heures par semaine.
   Données : assets/filter-lifespan-weekly.json (tableau figé issu du moteur de l'app). */
(function(){
  if (window.__rpurFilterLife) { window.__rpurFilterLife.initAll(); return; }

  var WEEKS_PER_MONTH = 4.33;
  var ALIASES = { 'shot': 'tir', 'tir-sportif': 'tir', 'motocycle': 'motorcycle', 'voyage': 'travel' };
  var tables = {};

  function loadTable(url){
    if (!tables[url]) {
      tables[url] = fetch(url).then(function(r){ return r.json(); }).then(function(t){ return t.weeks || t; });
    }
    return tables[url];
  }

  function perDay(v){
    var lang = document.documentElement.lang || 'fr';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v); }
    catch(e){ return v.toFixed(2) + ' ' + cur; }
  }

  // Valeur exacte, sinon le palier d'heures le plus proche
  function weeksFor(row, hours){
    if (!row || hours == null) return null;
    if (row[String(hours)] != null) return row[String(hours)];
    var best = null, diff = Infinity;
    Object.keys(row).forEach(function(k){
      var d = Math.abs(parseFloat(k) - hours);
      if (d < diff){ diff = d; best = row[k]; }
    });
    return best;
  }

  function init(root){
    if (root.__rpurInit) return;
    root.__rpurInit = true;

    var usage = root.getAttribute('data-usage') || '';
    usage = ALIASES[usage] || usage;
    var tirMode = root.getAttribute('data-tir-mode') || 'choice';
    var price = parseFloat(root.getAttribute('data-price')) || 0;
    var mode = (tirMode === 'stand') ? 'stand' : 'outdoor';
    var table = null;
    var defaultHours = root.getAttribute('data-default-hours');
    var defaultStand = root.getAttribute('data-default-stand');
    var userPicked = false;

    // Sélectionne un palier d'heures (si le bouton existe)
    function selectHours(h){
      var target = h && root.querySelector('.rpur-fl__btn[data-hours="' + h + '"]');
      if (!target) return;
      root.querySelectorAll('.rpur-fl__btn').forEach(function(b){ b.classList.toggle('is-selected', b === target); });
    }

    function rowKey(){
      if (usage === 'tir' && mode === 'stand' && table && table.stand) return 'stand';
      return usage;
    }

    function selectedHours(){
      var btn = root.querySelector('.rpur-fl__btn.is-selected') || root.querySelector('.rpur-fl__btn');
      if (btn) btn.classList.add('is-selected');
      return btn ? parseFloat(btn.getAttribute('data-hours')) : null;
    }

    function render(){
      var hs = root.querySelector('[data-hint-stand]');
      var ho = root.querySelector('[data-hint-outdoor]');
      var isStand = rowKey() === 'stand';
      if (hs) hs.hidden = !isStand;
      if (ho) ho.hidden = isStand;
      var res = root.querySelector('[data-result]');
      var fb = root.querySelector('[data-fallback]');
      var weeks = weeksFor(table && table[rowKey()], selectedHours());
      if (!weeks){ res.hidden = true; fb.hidden = false; return; }
      root.querySelector('[data-weeks]').textContent = weeks;
      root.querySelector('[data-months]').textContent = Math.max(1, Math.round(weeks / WEEKS_PER_MONTH));
      var wrap = root.querySelector('[data-perday-wrap]');
      if (price > 0){
        root.querySelector('[data-perday]').textContent = perDay(price / (weeks * 7));
        wrap.hidden = false;
      } else {
        wrap.hidden = true;
      }
      res.hidden = false;
      fb.hidden = true;
    }

    root.addEventListener('click', function(e){
      var btn = e.target.closest('.rpur-fl__btn');
      if (btn){
        userPicked = true;
        root.querySelectorAll('.rpur-fl__btn').forEach(function(b){ b.classList.toggle('is-selected', b === btn); });
        render();
        return;
      }
      var m = e.target.closest('.rpur-fl__mode');
      if (m){
        mode = m.getAttribute('data-mode');
        root.querySelectorAll('.rpur-fl__mode').forEach(function(b){ b.classList.toggle('is-selected', b === m); });
        // Durée par défaut propre au stand, tant que le visiteur n'a pas choisi lui même
        if (!userPicked) selectHours(mode === 'stand' ? defaultStand : defaultHours);
        render();
      }
    });

    loadTable(root.getAttribute('data-json'))
      .then(function(t){
        table = t;
        if (usage === 'tir' && mode === 'stand' && table.stand) selectHours(defaultStand);
        var modes = root.querySelector('[data-modes]');
        if (modes && usage === 'tir' && table.stand) modes.hidden = false;
        render();
      })
      .catch(function(){ render(); });
  }

  function initAll(){
    document.querySelectorAll('.rpur-fl').forEach(init);
  }

  // Simulateur précis dans une fenêtre, sans quitter la page
  var dialog;
  function getDialog(){
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'rpur-sim-dialog';
    dialog.innerHTML = '<button type="button" class="rpur-sim-dialog__close" aria-label="Close">&times;</button><iframe class="rpur-sim-dialog__frame" title="Simulator"></iframe>';
    document.body.appendChild(dialog);
    dialog.querySelector('.rpur-sim-dialog__close').addEventListener('click', function(){ dialog.close(); });
    dialog.addEventListener('click', function(e){ if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function(){ document.documentElement.style.overflow = ''; });
    return dialog;
  }
  document.addEventListener('click', function(e){
    var link = e.target.closest && e.target.closest('[data-rpur-sim]');
    if (!link) return;
    var d = getDialog();
    if (typeof d.showModal !== 'function') return;
    e.preventDefault();
    var frame = d.querySelector('iframe');
    if (frame.getAttribute('src') !== link.href) frame.setAttribute('src', link.href);
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
  });

  window.__rpurFilterLife = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
